import React from "react";
import GuiaSPESADT from "../../components/GuiaSPESADT";
import Receituario from "../../components/ReceituarioANS";
import LaudoMedico from "../../components/LaudoMedico";
import AltaFisio from "../../components/AltaFisio";
import AtestadoMedico from "../../components/AtestadoMedico";
import ReceituarioEspecial from "../../components/ReceituarioANSEspecial";
import ReceituarioOftalmo from "../../components/ReceituarioOftalmo";

interface EspecialidadeComPermissoes {
  idEspecialidade: number;
  dsEspecialidade: string;
  ativo: boolean;
  ativaAgendaOnlineSn: string;
  atendeMenorIdade: string;
  exibeQuestEpidem: string;
  realizaProced: string;
  cboTuss: string;
  guiaSadt: boolean;
  receituarioComum: boolean;
  receituarioEspecial: boolean;
  atestado: boolean;
  laudo: boolean;
  oftalmo: boolean | null;
  altaFisio: boolean | null;
}

interface DocumentosHandlerProps {
  especialidadeAtual: EspecialidadeComPermissoes | null;
}

const DocumentosHandler: React.FC<DocumentosHandlerProps> = ({ especialidadeAtual }) => {
  if (!especialidadeAtual) return null;

  return (
    <>
      {especialidadeAtual?.guiaSadt && <GuiaSPESADT />}
      {especialidadeAtual?.receituarioComum && <Receituario />}
      {especialidadeAtual?.receituarioEspecial && <ReceituarioEspecial />}
      {especialidadeAtual?.oftalmo && <ReceituarioOftalmo />}
      {especialidadeAtual?.atestado && <AtestadoMedico />}
      {especialidadeAtual?.altaFisio && <AltaFisio />}
      {especialidadeAtual?.laudo && <LaudoMedico />}
    </>
  );
};

export default DocumentosHandler;